import Vue from 'vue'
import VueRouter from 'vue-router'
import App from '@/App.vue'
import UserLoginPage from '@/views/user/UserLoginPage.vue'
import CourseLivePage from '@/views/user/CourseLivePage.vue'
import CourseReplayPage from '@/views/user/CourseReplayPage.vue'
import AdminLoginPage from '@/views/admin/AdminLoginPage.vue'
import AdminDashboardPage from '@/views/admin/AdminDashboardPage.vue'
import Play from '@/components/player/player.vue';
import Player from '@/components/player/lms.vue';
import ProgramList from '@/views/user/ProgramList.vue'

import store from '@/store';

Vue.use(VueRouter)

const routes = [
    {
        path: '/test',
        name: 'Test',
        component: App,
    },
    {
        path: '/',
        name: 'UserLoginPage',
        component: UserLoginPage,
    },
    {
        path: '/courselive',
        name: 'CourseLivePage',
        component: CourseLivePage,
    },
    {
        path: '/coursereplay',
        redirect: '/programlist',
    },
    {
        path: '/coursereplay/:lectureId',
        name: 'CourseReplayPage',
        component: CourseReplayPage,
    },
    {
        path: '/programlist',
        name: 'ProgramList',
        component: ProgramList,
    },
    {
        path: '/admin',
        name: 'AdminLoginPage',
        component: AdminLoginPage,
    },
    {
        path: '/admin_dashboard',
        name: 'AdminDashboardPage',
        component: AdminDashboardPage,
    },
    {
      path: '/player',
      name: 'player',
      component: Player,
    },

    // vod 다시보기
    // {
    //     path: '/coursereplay/:videoId',
    //     name: 'CourseReplayPage',
    //     component: CourseReplayPage,
    // },
    // {
    //     path: '/programlist',
    //     name: 'ProgramList',
    //     component: ProgramList,
    // },
    // {
    //   path: '/play',
    //   name: 'play',
    //   component: Play,
    // },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})



router.beforeEach((to, from, next) => {

    // if (to.path === '/player') {
    //     return next();
    // }

    if (to.path === '/admin') {
        store.dispatch('admin/checkAuth').then(() => {
            const isAdminLoggedIn = store.getters['admin/isLoggedIn'];
            if (isAdminLoggedIn) {
                next('/admin_dashboard'); 
            } else {
                next(); 
            }
        });
        return; 
    }

    if (to.path === '/admin_dashboard') {
        store.dispatch('admin/checkAuth').then(() => {
            const isAdminLoggedIn = store.getters['admin/isLoggedIn'];
            if (!isAdminLoggedIn) {
                next('/admin'); 
            } else {
                next(); 
            }
        });
        return; 
    }

    if (to.path === '/') {
        if (from.path === '/admin_dashboard') {
            store.dispatch('admin/logout').then(() => {
                console.log("확인1")
                next();
            });
        } else {
            store.dispatch('user/checkAuth').then(() => {
                const isLoggedIn = store.getters['user/isLoggedIn'];
                if (isLoggedIn) {
                    next('/programlist');
                } else {
                    next();
                }
            });
        }
        return;
    }

    store.dispatch('user/checkAuth').then(() => {
        const isLoggedIn = store.getters['user/isLoggedIn'];

        if (!isLoggedIn && to.path !== '/') {
            next('/'); 
        } else {
            next();
        }
    });
});


export default router
